import * as React from 'react';
import { cva, VariantProps } from 'class-variance-authority';
import { cn } from '../../utils/cn';

const drawerHeaderVariants = cva(
    'rocco-drawer-header flex flex-col space-y-2',
    {
        variants: {
            variant: {
                default:
                    'border-b border-gray-900/30 px-6 pb-4 pt-13.5 md:pb-4.5 md:pt-7',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    }
);

export const DrawerHeader = ({
    className,
    variant,
    ...props
}: React.HTMLAttributes<HTMLDivElement> &
    VariantProps<typeof drawerHeaderVariants>) => (
    <div
        className={cn(drawerHeaderVariants({ variant, className }))}
        {...props}
    />
);

DrawerHeader.displayName = 'DrawerHeader';
